import * as auth from "./auth";
import * as externalAuthorizations from "./externalAuthorizations.ts";
import * as config from "./config";
import * as users from "./users";
import * as roles from "./roles.ts";
import * as userLoginMethod from "./userLoginMethod.ts";
import * as files from "./files";
import * as activities from "./activities";
import * as supportEmails from "./supportEmails";
import * as backgroundTasks from "./backgroundTasks";
import * as notifications from "./notifications/inAppNotifications.ts";
import * as notificationChannels from "./notifications/notificationChannels.ts";
import * as notificationPreferences from "./notifications/notificationPreferences.ts";
import * as watcherPreferences from "./notifications/watcherPreferences.ts";
import * as accessTokens from "./accessTokens.ts";
import * as teams from "./teams.ts";
import * as systemAgents from "./systemAgents";
import * as owners from "./owners.ts";
import * as reportedErrors from "./reportedErrors.ts";
import * as reminderSchedules from "./reminderSchedules.ts";
import * as scim from "./scim";
import * as verifiedDomains from "./verifiedDomains";
import * as loginMethod from "./loginMethod";
import * as reviewable from "./reviewable";
import * as agentSessions from "./agentSessions";
import * as privateResources from "./privateResources";
import * as savedViews from "./savedViews";
import * as customPrompts from "./customPrompts";
import * as portalDiscovery from "./portalDiscovery";
import vendorToolkit from "./vendorToolkit";
import tprm from "./tprm";
import internal from "./internal";
import {UnauthorizedError} from "platformed-client/types";
import {PlatformedClient} from "platformed-client";
import {getFrontendEnvironment} from "../utils/environment";
import {
  getAccountId,
  RedirectResponse,
  RedirectTarget,
  redirectToAccountSelector,
  redirectUnauthorized,
  subscribeAccountId,
} from "../utils/auth";

const {app_url, release} = getFrontendEnvironment();

export const platformedClient = new PlatformedClient(app_url, release ?? undefined);

platformedClient.setErrorHandler(({response, json}) => {
  if (response.status === 401) {
    if (json?.sub_type === "missing_authorization") {
      throw new RedirectError(redirectUnauthorized());
    } else {
      throw new UnauthorizedError(json! as any);
    }
  } else if (response.status === 422) {
    if (json?.type_ === "unknown_account") {
      throw new RedirectError(redirectToAccountSelector());
    }
  }
});
subscribeAccountId(() => {
  platformedClient.setAccountId(getAccountId() as any /* Temporary cast while AccountId types don't match */);
});

export class RedirectError extends Error {
  response: RedirectResponse;
  constructor(response: RedirectResponse);
  constructor(location: string, target?: RedirectTarget);
  constructor(response: RedirectResponse | string, target?: RedirectTarget) {
    const resp = typeof response === "string" ? new RedirectResponse(response, target) : response;
    super(`Redirecting to ${resp.location}`);
    this.response = resp;
  }
  toString() {
    return `Redirecting to ${this.response.location}`;
  }
  get _isNominal() {
    return true;
  }
}

const api = {
  users,
  roles,
  vendorToolkit,
  tprm,
  auth,
  externalAuthorizations,
  config,
  userLoginMethod,
  loginMethod,
  files,
  activities,
  supportEmails,
  backgroundTasks,
  notifications,
  notificationChannels,
  notificationPreferences,
  accessTokens,
  teams,
  systemAgents,
  owners,
  reportedErrors,
  reminderSchedules,
  scim,
  verifiedDomains,
  watcherPreferences,
  reviewable,
  agentSessions,
  privateResources,
  savedViews,
  customPrompts,
  portalDiscovery,
  internal,
};

export default api;
